// Created by hejikun on 2017/10/25 0025.
let state = {
  guidance_doclist: [],
  isList: 0,
  isListFast: 0,
  guidance_ABClist: []
}

export default {
  state
}
